// @ts-nocheck

export default defineNuxtPlugin(() => {
  const PIXEL_ID = useRuntimeConfig().public.SNAP_PIXEL_ID || '7f766792-5da6-44ab-aeb0-74ba0585da63';

  (function (e, t, n) {
    if (e.snaptr) return;
    var a = (e.snaptr = function () {
      a.handleRequest
        ? a.handleRequest.apply(a, arguments)
        : a.queue.push(arguments);
    });
    a.queue = [];
    var s = 'script',
      r = t.createElement(s);
    r.async = !0;
    r.src = 'https://sc-static.net/scevent.min.js';
    var u = t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r, u);
  })(window, document);

  window.snaptr('init', PIXEL_ID);

  const route = useRoute();

  const snapTrack = (eventName: string, params?: any): void => {
    const ScCid = route.query.ScCid;
    const store = useKegelStore();
    window.snaptr('track', eventName, { ...params, ...store.userData, ScCid });
  };

  return {
    provide: {
      snapTrack,
    },
  };
});
